import { useContext } from 'react';
import { ExchangesContext } from 'providers/Exchanges';

const useExchanges = () => useContext(ExchangesContext);

export default useExchanges;
